module.exports = __webpack_public_path__ + "img/bx09-3.0d90e639.jpg";